import { useState } from "react";

import type { WidgetPreviewOptions } from "@go-novus/widget";

export type PreviewView = NonNullable<WidgetPreviewOptions["view"]>;
export type PreviewDevice = "desktop" | "mobile";

/** 页面传给预览栏的控制面：当前视图与设备，以及手动切换回调。 */
export interface PreviewControl {
  device: PreviewDevice;
  onDeviceChange: (device: PreviewDevice) => void;
  onViewChange: (view: PreviewView) => void;
  view: PreviewView;
}

/**
 * 预览跟着标签页走：alignedView 是当前标签指定的视图，null 表示保持当前
 * 视图。手动切换随时可用，下一个指定了视图的标签到来时按它重新对齐；
 * 设备选择不随标签改变。
 */
export function usePreviewControl(
  alignedView: PreviewView | null,
): PreviewControl {
  const [device, setDevice] = useState<PreviewDevice>("desktop");
  const [view, setView] = useState<PreviewView>(
    () => alignedView ?? "conversation",
  );
  const [lastTabView, setLastTabView] = useState(alignedView);
  if (lastTabView !== alignedView) {
    setLastTabView(alignedView);
    if (alignedView !== null) setView(alignedView);
  }
  return {
    device,
    onDeviceChange: setDevice,
    onViewChange: setView,
    view,
  };
}
